const APPLICATION_VERSION: string = "v4.2.0 25.02.2021";
export default APPLICATION_VERSION;
export const STEP_COUNT: number = 10;
export const STRIPE_PK_TEST: string = "pk_test_XkR3UAbPZ3AJfUUXdzzN8AWK";
export const STRIPE_PK_PROD: string = "pk_live_dl7UeWyUQnl7wcGK78OpyCks";
export const PRACTIQ_API_ENDPOINT: string =
	"https://public-api.practiq.com.au/api";
export const QV_MEDICAL_WEBSITE_API_KEY =
	"pjaA7K60Dg1rLyCazjvqG3hau9Noa05z5aNeEtSM";
export const QV_MEDICAL_WEBSITE_ENDPOINT =
	"https://e6m6nfvk4c.execute-api.ap-southeast-2.amazonaws.com/Prod";
export const LOCAL_HOST: string = "https://localhost:5005/api";
export const LAST_STAGE = 999;
export const QV_MEDICAL_PHONE_NUMBER = "6139662256";
export const EXTRA_AUTH_MESSAGE =
	"Authentication is required for this payment. Please confirm.";
export const BOOKING_APP_S3_BUCKET_URL =
	"https://bookingwidget.s3-ap-southeast-2.amazonaws.com/";
export const SAD_COLOURED =
	BOOKING_APP_S3_BUCKET_URL + "assets/svg/sad-coloured-01.svg";
export const DISKETTE_COLOURED =
	BOOKING_APP_S3_BUCKET_URL + "assets/svg/diskette-coloured-01.svg";
export const WARNING_COLOURED =
	BOOKING_APP_S3_BUCKET_URL + "assets/svg/warning-coloured-01.svg";
export const BLANK_MEDICARE =
	BOOKING_APP_S3_BUCKET_URL + "assets/photos/blank-medicare-card.png";
export const BLANK_HEALTHCARE =
	BOOKING_APP_S3_BUCKET_URL + "assets/photos/blank-healthcare-card.png";
export const ROOT_ID = "booking-widget-v4-root";
export const PRACTIQ_API_KEY = "00001-NEshShGA5ZNHOvul9oqhgDEd94zGqDBw"